import {
	API_GET_ALL_INSURANCE,
	API_GET_ALL_INSURANCE_SUCCESS,
	API_GET_ALL_INSURANCE_FAIL,
	API_SEARCH_INSURANCE,
	API_SEARCH_INSURANCE_SUCCESS,
	API_SEARCH_INSURANCE_FAIL
} from '../actions/insurance';
import { createReducer } from '@reduxjs/toolkit';
import { errorHandler, ErrorAction } from 'utils/error';

const initialState = {
    loading: false,
	list: []
};

const insurances = createReducer(initialState, {
	/** GET ALL **/
	[API_GET_ALL_INSURANCE]: (state, action) => {
		state.loading = true;
	},
	[API_GET_ALL_INSURANCE_FAIL]: (state, action) => {
		errorHandler('Mutuelle', ErrorAction.READ, action.error);
		state.loading = false;
	},
	[API_GET_ALL_INSURANCE_SUCCESS]: (state, action) => {
		state.loading = false;
		state.list = action.payload.data;
	},

	/** SEARCH **/
	[API_SEARCH_INSURANCE]: (state, action) => {
		state.loading = true;
	},
	[API_SEARCH_INSURANCE_FAIL]: (state, action) => {
		errorHandler('Mutuelle', ErrorAction.READ, action.error);
		state.loading = false;
	},
	[API_SEARCH_INSURANCE_SUCCESS]: (state, action) => {
		state.loading = false;
		state.list = action.payload.data;
	}

});

export default insurances;
